import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import { categories, articles } from '@/mocks/articles';
import { Link } from 'react-router-dom';

const heroBgImage = 'https://readdy.ai/api/search-image?query=Abstract%20modern%20digital%20art%20with%20warm%20coral%20pink%20and%20soft%20golden%20amber%20gradients%20flowing%20organically%2C%20minimalist%20clean%20background%20with%20subtle%20texture%2C%20luxurious%20and%20atmospheric%20design%2C%20no%20text%2C%20no%20objects%2C%20pure%20abstract%20gradient%20art%2C%20editorial%20quality%2C%20smooth%20color%20transitions%2C%20warm%20inviting%20tone&width=1920&height=1080&seq=home-hero-bg-01&orientation=landscape';

const previewImage = 'https://readdy.ai/api/search-image?query=Modern%20clean%20website%20dashboard%20interface%20mockup%20displayed%20on%20a%20floating%20screen%2C%20warm%20coral%20and%20soft%20cream%20color%20palette%2C%20minimalist%20UI%20design%20with%20cards%20and%20content%20grids%2C%20elegant%20digital%20product%20presentation%2C%20soft%20shadows%2C%20clean%20composition%2C%20editorial%20quality&width=1400&height=800&seq=home-preview-02&orientation=landscape';

const testimonialImage = 'https://readdy.ai/api/search-image?query=Dramatic%20abstract%20digital%20illustration%20of%20social%20media%20screenshots%20and%20news%20headlines%20collage%2C%20warm%20coral%20pink%20and%20amber%20color%20scheme%2C%20modern%20minimalist%20composition%2C%20clean%20background%2C%20editorial%20style%2C%20representing%20viral%20social%20media%20content&width=800&height=1000&seq=home-testimonial-03&orientation=portrait';

const appMockupImage = 'https://readdy.ai/api/search-image?query=Smartphone%20mockup%20showing%20a%20modern%20mobile%20app%20interface%20with%20news%20feed%20design%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20minimalist%20UI%20design%2C%20floating%20phone%20on%20clean%20background%2C%20app%20store%20presentation%20style%2C%20editorial%20quality&width=700&height=1200&seq=home-app-mockup-04&orientation=portrait';

export default function Home() {
  const topArticle = articles.find((a) => a.isTop);
  const otherArticles = articles.filter((a) => !a.isTop).slice(0, 4);

  return (
    <>
      <SEOHead
        pageType="website"
      />

      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src={heroBgImage}
              alt="51网址导航 - 网红塌房黑料吃瓜视频实时追踪"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
          </div>

          <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-20">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white leading-tight mb-4">
              全网每日网红塌房
            </h1>
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading text-white leading-tight mb-6">
              黑料吃瓜视频实时追踪
            </h2>
            <p className="text-white/80 text-sm md:text-base max-w-2xl mx-auto leading-relaxed mb-8">
              51网址导航 — 最全最快的网红八卦资讯聚合平台，24小时不间断更新网红塌房、黑料曝光、吃瓜视频，
              让你不错过任何一个热门爆料。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="#categories"
                className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors duration-200 text-sm whitespace-nowrap cursor-pointer"
              >
                立即吃瓜
              </a>
              <a
                href="#app-download"
                className="px-8 py-3 border-2 border-white/30 text-white font-medium rounded-full hover:bg-white/10 transition-colors duration-200 text-sm whitespace-nowrap cursor-pointer"
              >
                下载APP
              </a>
            </div>
          </div>

          <div className="absolute bottom-0 left-0 right-0 px-4 md:px-12 pb-0">
            <div className="max-w-6xl mx-auto">
              <div className="relative rounded-t-3xl overflow-hidden">
                <img
                  src={previewImage}
                  alt="51网址导航平台界面预览"
                  className="w-full h-auto object-cover object-top"
                />
                <div className="absolute inset-0 rounded-t-3xl ring-1 ring-inset ring-white/10"></div>
              </div>
            </div>
          </div>
        </section>

        {/* Category Grid Section */}
        <section id="categories" className="py-16 md:py-24 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="mb-12">
              <h2 className="text-3xl md:text-4xl font-heading text-foreground-900 mb-3">
                热门爆料分类
              </h2>
              <p className="text-foreground-600 text-sm md:text-base">
                三大核心板块，覆盖全网网红八卦资讯
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {categories.map((cat, index) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group bg-background-50 rounded-2xl p-5 flex flex-col transition-all duration-300 hover:scale-[1.02]"
                >
                  <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden mb-4">
                    <img
                      src={cat.imageUrl}
                      alt={cat.name}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className={`absolute inset-0 ${
                      index === 0 ? 'bg-primary-500/10' : index === 1 ? 'bg-accent-500/10' : 'bg-secondary-500/10'
                    }`}></div>
                  </div>
                  <h3 className="text-lg font-heading text-foreground-900 text-center mb-1">
                    {cat.name}
                  </h3>
                  <p className="text-3xl font-bold text-foreground-900 text-center mb-4">
                    {cat.count}
                  </p>
                  <p className="text-xs text-foreground-500 text-center mb-4">
                    24H 实时更新
                  </p>
                  <div className={`w-full py-2.5 rounded-full text-center text-sm font-medium transition-colors duration-200 ${
                    index === 0
                      ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                      : 'bg-background-50 text-foreground-700 border border-foreground-300 hover:bg-background-100'
                  }`}>
                    浏览分类
                  </div>
                  <p className="text-xs text-foreground-400 text-center mt-2">
                    {cat.description}
                  </p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Feature Grid - Hot Tracking */}
        <section className="py-16 md:py-24 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 leading-tight">
                实时<span className="text-primary-500">追踪</span>热点
              </h2>
              <p className="text-foreground-600 text-sm mt-2">
                不错过任何一个热门爆料
              </p>
            </div>

            {topArticle && (
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <Link
                  to={`/article/${topArticle.id}`}
                  className="group relative rounded-2xl overflow-hidden aspect-[4/5] lg:aspect-auto"
                >
                  <img
                    src={topArticle.imageUrl}
                    alt={topArticle.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                    <span className="inline-block px-3 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full mb-3">
                      今日 TOP1 塌房
                    </span>
                    <h3 className="text-white text-lg md:text-xl font-heading mb-2 line-clamp-2">
                      {topArticle.title}
                    </h3>
                    <p className="text-white/70 text-sm line-clamp-2">
                      {topArticle.excerpt}
                    </p>
                    <div className="flex items-center gap-3 mt-3 text-white/60 text-xs">
                      <span>{topArticle.views} 阅读</span>
                      <span>{topArticle.publishDate}</span>
                    </div>
                  </div>
                </Link>

                <div className="flex flex-col gap-6">
                  {otherArticles.slice(0, 2).map((article, idx) => (
                    <Link
                      key={article.id}
                      to={`/article/${article.id}`}
                      className="group relative rounded-2xl overflow-hidden flex-1 min-h-[180px]"
                    >
                      <img
                        src={article.imageUrl}
                        alt={article.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                      <div className={`absolute inset-0 ${
                        idx === 0 ? 'bg-secondary-500/30' : 'bg-accent-500/20'
                      }`}></div>
                      <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-transparent"></div>
                      <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                        <span className={`inline-block px-2.5 py-1 text-xs font-medium rounded-full mb-2 ${
                          idx === 0 ? 'bg-secondary-100 text-secondary-900' : 'bg-accent-100 text-accent-900'
                        }`}>
                          {article.category}
                        </span>
                        <h3 className="text-white text-base md:text-lg font-heading line-clamp-2 mb-1">
                          {article.title}
                        </h3>
                        <div className="flex items-center gap-3 text-white/60 text-xs">
                          <span>{article.views} 阅读</span>
                          <span>{article.duration}</span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>
        </section>

        {/* Testimonial Section */}
        <section className="py-16 md:py-24 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
              <div className="lg:w-2/5">
                <div className="rounded-2xl overflow-hidden bg-accent-100 aspect-[3/4]">
                  <img
                    src={testimonialImage}
                    alt="用户真实评价"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              <div className="lg:w-3/5 flex flex-col justify-center">
                <p className="text-foreground-500 text-sm mb-3">(用户真实评价)</p>
                <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 leading-tight mb-8">
                  百万吃瓜群众<span className="text-foreground-400">的首选平台</span>
                </h2>
                <blockquote className="text-foreground-700 text-base md:text-lg leading-relaxed mb-6 border-l-4 border-primary-500 pl-5">
                  "自从发现了51网址导航，每天刷一刷就能掌握全网网红最新动态。塌房追踪功能太实用了，再也不用在多个平台之间来回切换，所有吃瓜资讯一个网站全搞定！"
                </blockquote>
                <p className="text-foreground-900 font-medium">
                  — 资深吃瓜群众 @小瓜农
                </p>
                <div className="flex items-center gap-3 mt-8">
                  <button className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-300 text-foreground-500 hover:bg-background-200 transition-colors duration-200 cursor-pointer">
                    <i className="ri-arrow-left-line text-lg"></i>
                  </button>
                  <button className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 cursor-pointer">
                    <i className="ri-arrow-right-line text-lg"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* App Download CTA */}
        <section id="app-download" className="py-16 md:py-24 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row gap-0 rounded-2xl overflow-hidden">
              <div className="lg:w-1/2 bg-accent-100 relative min-h-[400px] md:min-h-[500px] flex items-end">
                <div className="absolute top-6 left-6 z-10">
                  <span className="text-foreground-600 text-xs font-medium">51网址导航 APP</span>
                </div>
                <div className="absolute bottom-6 left-6 z-10">
                  <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 leading-tight">
                    随时随地<br />追踪网红黑料<br />吃瓜不等待
                  </h2>
                </div>
                <img
                  src={appMockupImage}
                  alt="51网址导航APP界面"
                  className="absolute right-0 bottom-0 w-auto h-[110%] object-contain object-bottom"
                />
              </div>

              <div className="lg:w-1/2 bg-background-50 flex flex-col items-center justify-center px-8 py-12 md:py-16">
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-4 text-center">
                  随时随地<br />追踪网红黑料
                </h2>
                <p className="text-foreground-600 text-sm md:text-base text-center max-w-md mb-8 leading-relaxed">
                  下载51网址导航APP，开启推送通知，网红塌房、黑料曝光、吃瓜视频第一时间送达你的手机。iOS和Android双平台支持。
                </p>
                <a
                  href="#"
                  className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors duration-200 text-sm whitespace-nowrap cursor-pointer"
                >
                  立即下载
                  <i className="ri-arrow-right-line text-base w-5 h-5 flex items-center justify-center"></i>
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}